import journeysQueries from "apps/journeys/utils/gql/queries";
import { fetchFromGraphql } from "entities/helpers/gqlCall";

export const fetchJourneyDetails = async (journeyId, taskOwnerUserId, taskStatuses, selectedDate) => {
  const query = journeysQueries.fetchJourneyDetails;
  const queryVars = {
    journeyId,
    taskOwnerUserId,
    taskStatuses,
    selectedDate,
  };

  const { journey } = await fetchFromGraphql(query, queryVars, "journey");
  return journey || {};
};
